// @ts-nocheck
import React from 'react';
import { ApplyPluginsType, dynamic } from '/Users/xxy1/code/yanhua/香港/ctm-pc/node_modules/umi/node_modules/@umijs/runtime';
import * as umiExports from './umiExports';
import { plugin } from './plugin';
import LoadingComponent from '@/components/Loading';

export function getRoutes() {
  const routes = [
  {
    "path": "/",
    "redirect": "/home",
    "exact": true
  },
  {
    "path": "/",
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__home' */'@/pages/home'), loading: LoadingComponent}),
    "exact": true
  },
  {
    "path": "/home",
    "title": "home.title",
    "name": "home",
    "isMenu": true,
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__home' */'@/pages/home'), loading: LoadingComponent}),
    "exact": true
  },
  {
    "path": "/detail",
    "title": "detail.title",
    "name": "detail",
    "isMenu": true,
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__detail' */'@/pages/detail'), loading: LoadingComponent}),
    "exact": true
  },
  {
    "path": "/filter",
    "title": "filter.title",
    "name": "filter",
    "isMenu": true,
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__filter' */'@/pages/filter'), loading: LoadingComponent}),
    "exact": true
  },
  {
    "path": "/special",
    "name": "special",
    "isMenu": true,
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__special' */'@/pages/special'), loading: LoadingComponent}),
    "exact": true
  },
  {
    "path": "/search",
    "title": "search.title",
    "name": "search",
    "isMenu": true,
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__search' */'@/pages/search'), loading: LoadingComponent}),
    "exact": true
  },
  {
    "path": "/collect",
    "name": "collect",
    "isMenu": true,
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__collect' */'@/pages/collect'), loading: LoadingComponent}),
    "exact": true
  },
  {
    "path": "/more",
    "name": "more",
    "isMenu": true,
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__more' */'@/pages/more'), loading: LoadingComponent}),
    "exact": true
  },
  {
    "path": "/profile",
    "name": "profile",
    "isMenu": true,
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__profile' */'@/pages/profile'), loading: LoadingComponent}),
    "exact": true
  },
  {
    "path": "/login",
    "name": "login",
    "isMenu": true,
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__login' */'@/pages/login'), loading: LoadingComponent}),
    "exact": true
  },
  {
    "path": "/order",
    "name": "order",
    "isMenu": true,
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__order' */'@/pages/order'), loading: LoadingComponent}),
    "exact": true
  },
  {
    "path": "/billPay",
    "name": "billPay",
    "isMenu": true,
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__order__billPay' */'@/pages/order/billPay'), loading: LoadingComponent}),
    "exact": true
  },
  {
    "path": "/qrCodePay",
    "name": "qrCodePay",
    "isMenu": true,
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__order__qrCodePay' */'@/pages/order/qrCodePay'), loading: LoadingComponent}),
    "exact": true
  },
  {
    "path": "/internetPay",
    "name": "internetPay",
    "isMenu": true,
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__order__internetPay' */'@/pages/order/internetPay'), loading: LoadingComponent}),
    "exact": true
  },
  {
    "path": "/hmvod/detail",
    "title": "detail.title",
    "name": "detail",
    "isMenu": true,
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'components__HMVOD__detail' */'@/components/HMVOD/detail'), loading: LoadingComponent}),
    "exact": true
  },
  {
    "path": "/hmvod/more",
    "name": "more",
    "isMenu": true,
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'components__HMVOD__more' */'@/components/HMVOD/more'), loading: LoadingComponent}),
    "exact": true
  },
  {
    "path": "/game/detail",
    "name": "detail",
    "isMenu": true,
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__game__detail' */'@/pages/game/detail'), loading: LoadingComponent}),
    "exact": true
  },
  {
    "path": "/game/filter",
    "name": "filter",
    "isMenu": true,
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__game__filter' */'@/pages/game/filter'), loading: LoadingComponent}),
    "exact": true
  },
  {
    "path": "/game/search",
    "name": "search",
    "isMenu": true,
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__game__search' */'@/pages/game/search'), loading: LoadingComponent}),
    "exact": true
  },
  {
    "path": "/game/more",
    "name": "more",
    "isMenu": true,
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__game__more' */'@/pages/game/more'), loading: LoadingComponent}),
    "exact": true
  },
  {
    "path": "/live/allLive",
    "name": "allLive",
    "isMenu": true,
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__live__allLive' */'@/pages/live/allLive'), loading: LoadingComponent}),
    "exact": true
  },
  {
    "path": "/live/liveDetail",
    "name": "liveDetail",
    "isMenu": true,
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'p__live__liveDetail' */'@/pages/live/liveDetail'), loading: LoadingComponent}),
    "exact": true
  },
  {
    "path": "/myTV/more",
    "name": "myTvMore",
    "isMenu": true,
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'components__MyTV__conponents__more' */'@/components/MyTV/conponents/more'), loading: LoadingComponent}),
    "exact": true
  },
  {
    "path": "/myTV/liveMore",
    "name": "myTvLiveMore",
    "isMenu": true,
    "component": dynamic({ loader: () => import(/* webpackChunkName: 'components__MyTV__conponents__liveMore' */'@/components/MyTV/conponents/liveMore'), loading: LoadingComponent}),
    "exact": true
  }
];

  // allow user to extend routes
  plugin.applyPlugins({
    key: 'patchRoutes',
    type: ApplyPluginsType.event,
    args: { routes },
  });

  return routes;
}
